import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function AreasWeCover() {
  return <section id="areaswecover" className="bg-black text-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {}
          <div className="space-y-6">
            <h2 className="text-6xl md:text-7xl font-bold font-serif tracking-tighter leading-none text-[#F2F2EE]">
              Areas We Cover
            </h2>
            
            <div className="space-y-4 text-background/90 font-sans text-lg leading-relaxed">
              <p>Nick Landscapes proudly serves Dulwich and its surrounding neighbourhoods as part of our wider South London coverage. Whether you're in Dulwich Village, East Dulwich, West Dulwich, Herne Hill, Forest Hill, or Crystal Palace, our team is on hand to deliver expert driveway solutions to your door. From brand new driveway installations and full resurfacing to essential maintenance and repairs, we offer high-quality workmanship tailored to Dulwich properties — with a strong understanding of the area's period homes and local planning considerations.</p>
              
              
            </div>
          </div>

          {}
          <div className="relative w-full">
            <AspectRatio ratio={4 / 3}>
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d79543.2484341568!2d-0.15466845!3d51.44115885!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487603f999999999%3A0x1234567890abcdef!2sSouth%20London!5e0!3m2!1sen!2suk!4v1710000000000!5m2!1sen!2suk" className="w-full h-full rounded-tl-3xl rounded-br-3xl shadow-lg border-0" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Nick Landscapes Service Areas Map"></iframe>
            </AspectRatio>
          </div>

        </div>
      </div>
    </section>;
}